<template>
  <div
    class="v-select-basic"
    @click.self="toggleDropdown"
    :class="{ 'v-select-basic--active': isOpen }"
    v-click-outside="closeDropdown"
  >
    <div
      class="v-select-basic__label"
      :class="{
        'v-select-basic__label--float': selectedOption || isOpen,
        'v-select-basic__label--float--active': isOpen
      }"
    >
      {{ selectorLabel }}
    </div>
    <div class="v-select-basic__selected-option">
      {{ selectedOption ? selectedOption.label : "" }}
    </div>
    <v-icon class="v-select-basic__icon" name="arrow-key-down" width="24" />
    <div
      class="v-select-basic__dropdown"
      :class="{
        'v-select-basic__dropdown--mobile': isMobile && !mobileTakeover,
        'v-select-basic__dropdown--mobile-takeover': isMobile && mobileTakeover,
        'v-select-basic__dropdown--desktop': !isMobile
      }"
      v-show="isOpen"
      @click.self="toggleDropdown"
    >
      <span
        class="v-select-basic__dropdown__close"
        v-if="isMobile && mobileTakeover"
        @click="closeDropdown"
      >
        Luk
      </span>
      <ul
        class="v-select-basic__options"
        :class="{
          'v-select-basic__options--mobile': isMobile && !mobileTakeover,
          'v-select-basic__options--mobile-takeover':
            isMobile && mobileTakeover,
          'v-select-basic__options--desktop': !isMobile
        }"
      >
        <li
          v-for="option in options"
          class="v-select-basic__option"
          :class="{
            'v-select-basic__option--selected':
              option.value === (selectedOption ? selectedOption.value : value)
          }"
          :key="option.value"
          @click="selectOption(option)"
        >
          {{ option.label }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "VSelectBasic",
  props: {
    label: String,
    options: Array,
    selectorLabel: String,
    value: [String, Object],
    initialValue: [String, Object],
    mobileTakeover: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
      mobileBreakpoint: 768,
      windowWidth: window.innerWidth
    };
  },
  created() {
    window.addEventListener("resize", this.updateWindowWidth);
    this.initializeSelectedOption();
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  computed: {
    isMobile() {
      return this.windowWidth < this.mobileBreakpoint;
    }
  },
  methods: {
    initializeSelectedOption() {
      if (this.initialValue) {
        this.selectedOption = this.options.find(
          option => option.value === this.initialValue
        );
        if (this.selectedOption) {
          this.$emit("input", this.selectedOption.value);
        }
      } else if (this.value) {
        this.selectedOption = this.options.find(
          option => option.value === this.value
        );
      }
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.$emit("input", option.value);
      this.closeDropdown();
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    handleKeydown(event) {
      if (event.key === "Escape") {
        this.closeDropdown();
      }
    }
  },
  directives: {
    clickOutside: {
      bind: function(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression](event);
          }
        };
        document.addEventListener("click", el.clickOutsideEvent);
      },
      unbind: function(el) {
        document.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../sass/component.scss";
@import "./v-select-basic.scss";
</style>
